
import { Badge } from "@/components/ui/badge";
import { Task } from "@/types/task";

const priorityColors: Record<Task['priority'], string> = {
  low: "bg-gray-100 text-gray-800",
  medium: "bg-blue-100 text-blue-800", 
  high: "bg-orange-100 text-orange-800",
  urgent: "bg-red-100 text-red-800"
};

const statusColors: Record<Task['status'], string> = {
  pending: "bg-yellow-100 text-yellow-800",
  in_progress: "bg-blue-100 text-blue-800",
  under_review: "bg-purple-100 text-purple-800",
  completed: "bg-green-100 text-green-800",
  cancelled: "bg-gray-100 text-gray-800"
};

export const priorityLabels: Record<Task['priority'], string> = {
  low: "منخفضة",
  medium: "متوسطة",
  high: "عالية", 
  urgent: "عاجلة"
};

export const statusLabels: Record<Task['status'], string> = {
  pending: "في الانتظار",
  in_progress: "قيد التنفيذ",
  under_review: "قيد المراجعة",
  completed: "مكتملة",
  cancelled: "ملغاة"
};

export const TaskPriorityBadge = ({ priority }: { priority: Task['priority'] }) => (
  <Badge className={priorityColors[priority]}>
    {priorityLabels[priority]}
  </Badge>
);

export const TaskStatusBadge = ({ status }: { status: Task['status'] }) => (
  <Badge className={statusColors[status]}>
    {statusLabels[status]}
  </Badge>
);
